import { useTranslation } from 'react-i18next';

import BioscopeStatusBox from '@/components/molecules/BioscopeStatusBox';
import ContentBlock from '@/components/molecules/ContentBlock';
import type { RetryProps } from '@/components/retryFailedQueries';
import SomethingHappened from '@/components/SomethingHappened';
import type { DomainCageStatus } from '@/domain/cages';

import ViewButton from './ViewButton';

interface CageStatusCardProps {
    cageStatus: DomainCageStatus | null;
    measurementCount: number;
    isLoading: boolean;
    isOptoScaleAdmin: boolean;
    isSmolt: boolean;
    showBioscopeInspectionLink: boolean;
    /** Set when the pen's bioscope status failed to load: the error state with Try again replaces it. */
    loadError?: RetryProps | null;
    cageUrl: string;
}

/** The bioscope in the pen, its live position and the fish it has measured. */
export default function CageStatusCard(props: CageStatusCardProps) {
    const {
        cageStatus,
        measurementCount,
        isLoading,
        isOptoScaleAdmin,
        isSmolt,
        showBioscopeInspectionLink,
        loadError,
        cageUrl,
    } = props;
    const { t } = useTranslation();

    const currentBioscopeId = cageStatus?.currentBioscope?.id;

    return (
        <ContentBlock
            title={t('cageDashboard.common.cageStatus')}
            spacing="none"
            headerActions={<ViewButton to={`${cageUrl}/dashboard/bioscope`} />}>
            {loadError ? (
                <SomethingHappened {...loadError} />
            ) : (
                <BioscopeStatusBox
                    cageStatus={cageStatus}
                    measurementCount={measurementCount}
                    isLoading={isLoading}
                    isOptoScaleAdmin={isOptoScaleAdmin}
                    isSmolt={isSmolt}
                    showBioscopeInspectionLink={showBioscopeInspectionLink}
                    bioscopeInspectionLink={
                        currentBioscopeId ? `${cageUrl}/bioscope/${currentBioscopeId}` : ''
                    }
                    historicalBioscopeInspectionLink={(bioscopeId) =>
                        `${cageUrl}/bioscope/${bioscopeId}`
                    }
                />
            )}
        </ContentBlock>
    );
}
